import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GET_APP_NAVIGATION_ITEMS, GET_ORG_NAVIGATION_ITEMS, GET_PROJ_NAVIGATION_ITEMS, NAVIGATION_QUERY_KEY_FIRST_ITEM } from 'ze-api-contract/user-v2/navigation-items';
const _navigationItemsKeys = createQueryKeys(NAVIGATION_QUERY_KEY_FIRST_ITEM, {
    organizationList: (queryParams)=>({
            queryKey: [
                GET_ORG_NAVIGATION_ITEMS,
                JSON.stringify(queryParams)
            ]
        }),
    projectList: (organization, queryParams)=>({
            queryKey: [
                GET_PROJ_NAVIGATION_ITEMS,
                organization,
                JSON.stringify(queryParams)
            ]
        }),
    applicationList: (organization, project, queryParams)=>({
            queryKey: [
                GET_APP_NAVIGATION_ITEMS,
                organization,
                project,
                JSON.stringify(queryParams)
            ]
        })
});
export const navigationItemsKeys = _navigationItemsKeys;
